module.exports = __webpack_public_path__ + "static/media/vf_wwallet_core.fdbf75f1.svg";